export const isConfigurationUpdatedFormatValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.Auto === undefined || response.data.Server === undefined || response.data.Web === undefined) {
        return false;
    }

    if (
        response.data.Auto.check === undefined ||
        response.data.Auto.download === undefined ||
        response.data.Auto.install === undefined ||
        response.data.Auto.install_delay === undefined ||
        response.data.Auto.install_new_dbs === undefined ||
        response.data.Auto.interval === undefined ||
        response.data.Auto.night_check === undefined ||
        response.data.Auto.night_check_interval === undefined ||
        response.data.Auto.night_check_start === undefined ||
        response.data.Auto.night_check_end === undefined ||
        response.data.Auto.reboot_delay === undefined
    ) {
        return false;
    }

    if (response.data.Server.port === undefined) {
        return false;
    }

    if (response.data.Web.host === undefined || response.data.Web.port === undefined) {
        return false;
    }

    return true;
};

export const isShowDialogFormatValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    return true;
};

export const isHideDialogFormatValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.dialogID === undefined) {
        return false;
    }

    return true;
};

export const isDownloadProgressFormatValid = (response) => {
    if (response.data === undefined) {
        return false;
    }

    if (response.data.zip_size === undefined || response.data.downloaded_size === undefined) {
        return false;
    }

    return true;
};
